import {
  TableColumns,
  TableFilterTab,
} from '../../../../../../ui-components/lib/table/table.model';
import { ActionList } from '../../../../../common/models/action-list.model';

export const POSITION_LIST_COLUMN_IDENTIFIERS = {
  STATUS: 'status',
  FILLED_STATUS: 'filled_status',
};

export const POSITION_LIST_COLUMNS: TableColumns[] = [
  {
    header: '',
  },
  {
    header: 'positions_list_screen_identifier_table_header',
    showViewIcon: true,
    isSortable: true,
    sortKey: 'identifier][type',
  },
  {
    header: 'positions_list_screen_name_table_header',
    isSortable: true,
    sortKey: 'name][type',
  },
  {
    header: 'positions_list_screen_assigned_user_table_header',
    isSortable: true,
    sortKey: 'incumbent][type',
  },
  {
    header: 'positions_list_screen_direct_manager_table_header',
  },
  {
    header: 'positions_list_screen_status_table_header',
    identifier: POSITION_LIST_COLUMN_IDENTIFIERS.STATUS,
  },
  {
    header: 'positions_list_screen_filled_status_table_header',
    identifier: POSITION_LIST_COLUMN_IDENTIFIERS.FILLED_STATUS,
  },
  { header: '' },
];

export const ACTIONS_INDEXES = {
  VIEW: 0,
  EDIT: 1,
  ACTIVATE: 2,
  DEACTIVATE: 3,
  DELETE: 4,
};

export const ACTIONS_MENU_ITEMS: ActionList[] = [
  {
    key: 'view',
    hasIcon: true,
    label: 'view_details_action_item',
    hasDivider: false,
    labelCustomStyle: '',
  },
  {
    key: 'edit',
    hasIcon: true,
    label: 'edit_action_item',
    hasDivider: true,
    labelCustomStyle: '',
  },
  {
    key: 'activate',
    hasIcon: true,
    label: 'activate_action_item',
  },
  {
    key: 'deactivate',
    hasIcon: true,
    label: 'deactivate_action_item',
    labelCustomStyle: 'text-destructive-500!',
  },
  {
    key: 'delete',
    hasIcon: true,
    label: 'delete_action_item',
    labelCustomStyle: 'text-destructive-500!',
  },
];

export const POSITION_LIST_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
  {
    key: 'active',
    identifier: 'active',
    label: 'table_filter_tab_active_label',
    active: false,
    iconName: 'active',
  },
  {
    key: 'inactive',
    identifier: 'inactive',
    label: 'table_filter_tab_inactive_label',
    active: false,
    iconName: 'inactive',
  },
];
